import {html, type TemplateResult} from 'lit';

export function mask(siteName: string, title: string, gdprUrl: string, externalEmbedSettings: string): TemplateResult {
  let maskTitle = '';
  if (siteName === 'opinary') {
    maskTitle = 'Ja, ich möchte mir die Umfrage von Opinary ansehen.';
  } else if (siteName === 'civey') {
    maskTitle = 'Leider können wir Ihnen diesen Inhalt von Civey ohne Ihre Zustimmung nicht anzeigen.';
  } else {
    maskTitle = 'Empfohlener externer Inhalt';
  }

  return html`
    <div class="externalembed__mask">
      <div class="externalembed__iframewrapper">
        <div class="mid-wrapper">
          <div class="externalembed__verticalcenterer">
            <h4 class="externalembed__title">${maskTitle}</h4>
            ${middleDeco(siteName, title, gdprUrl, externalEmbedSettings)}
          </div>
        </div>
        ${botDeco(siteName)}
      </div>
    </div>`;
}

const middleDeco = (site: string, title: string, gdprUrl: string, externalEmbedSettings: string) => {
  const videoSites = ['sky', 'eurosport', 'youtube'];
  const maskType = videoSites.includes(site) ? 'Videos' : 'Beiträge';
  const contentType = videoSites.includes(site) ? 'Videos' : 'Inhalte';

  if (site === 'civey') {
    return html`
      <div class="externalembed__text">Zur Darstellung dieses Inhalts benötigen wir Ihr nachträgliches Einverständnis
      </div>
      <button class="externalembed__optin button">Jetzt zustimmen</button>`;
  } else {
    return html`
      <span class="externalembed__icon"></span>
      <div class="externalembed__text externalembed__info">Mit einem Klick können Sie die ${title}-${maskType} anzeigen
        lassen oder wieder ausblenden.
      </div>
      <div class="externalembed__optin-toggle">
        <label class="switch animate">
          <input type="checkbox">
          <span class="toggle">
                <span class="ball"></span>
              </span>
        </label>
        Externe ${contentType} anzeigen
      </div>
      <h4 class="externalembed__text externalembed__dataschutz">
        Ich bin damit einverstanden, dass mir externe Inhalte angezeigt werden.
        Damit können personenbezogene Daten an Drittplattformen übermittelt werden.
        Mehr dazu in unserer <a href="${gdprUrl}">Datenschutzerklärung</a> und <a href="${externalEmbedSettings}">Zustimmungen
        zu externen Inhalten</a>.
      </h4>`;
  }
};

const botDeco = (site: string) => {
  if (site === 'civey') {
    return html`
      <div class="externalembed__box">
        <div class="line_light">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
        <div class="line_light">
          <div class="line l2"></div>
          <div class="circle"></div>
        </div>
        <div class="line_light">
          <div class="line l3"></div>
          <div class="circle"></div>
        </div>
        <div class="line_light">
          <div class="line l4"></div>
          <div class="circle"></div>
        </div>
      </div>`;
  }
  return html``;
};
